// Global
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { useEffect, useState } from 'react';

const useIsEditing = () => {
  const context = useSitecoreContext();
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (context?.sitecoreContext?.pageEditing) {
      setIsEditing(true);
    }
  }, [context?.sitecoreContext?.pageEditing]);

  return isEditing;
};

export default useIsEditing;
